












import Vue from "vue";
export default Vue.extend({
  props: {
    profile: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      document: [
        {
          text: "Despachos",
          icon: "fas fa-paper-plane",
          to: { name: `dispatch${this.profile}` },
        },
      ],
    };
  },
});
